<template>
  <div
    id="wrapper"
    :class="[
      'forced',
      open
        ? width > tabSize
          ? ''
          : 'full-layout'
        : width > tabSize
        ? 'enlarged'
        : 'full-layout'
    ]"
  >
    <Header />
    <Sidebar />
    <vue-custom-scrollbar
      id="scroll-area"
      class="scroll-area"
      :settings="settings"
    >
      <div class="content">
        <router-view />
      </div>
    </vue-custom-scrollbar>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Header from "@/containers/Header/Header";
import Sidebar from "@/containers/Sidebar/Sidebar";
import { TAB_SIZE, SET_HEADER_INFO } from "@/store/mutation-types";

import vueCustomScrollbar from "vue-custom-scrollbar";

export default {
  name: "MainApp",
  components: {
    Header,
    Sidebar,
    vueCustomScrollbar
  },
  data() {
    return {
      settings: {
        suppressScrollY: false,
        suppressScrollX: true,
        wheelPropagation: false
      },
      tabSize: TAB_SIZE
    };
  },
  computed: {
    ...mapState("setting", ["open", "width"]),
    ...mapState("header", ["loadingHeader", "errorMessagesHeader"])
  },
  mounted() {
    this[SET_HEADER_INFO]();
  },
  watch: {
    $route: function() {
      this[SET_HEADER_INFO]();
    }
  },
  methods: {
    ...mapActions("header", [SET_HEADER_INFO])
  }
};
</script>

<style lang="scss">
#wrapper {
  height: 100%;
  overflow: hidden;
  width: 100%;
}
.scroll-area {
  position: relative;
  margin: auto;
  width: 100%;
  height: 100%;
}
.content {
  margin-right: 240px;
  margin-top: 68px;
  padding: 20px 0;

  @media (min-width: 768px) {
    padding-left: 20px;
    padding-right: 20px;
  }

  #wrapper.enlarged & {
    margin-right: 70px;
  }
  #wrapper.full-layout & {
    margin-right: 0;
  }
}
</style>
